'use client';

import { useRouter } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { useAlertProvider } from '@cvs-web/splash-components';
import { I18nMessage } from '@cvsdigital_web/react-cmk-i18n';

export function useShowSuccessAlert(currentPageURL: string) {
  const router = useRouter();
  const { setAlerts } = useAlertProvider();
  const hasShownRef = useRef(false);

  useEffect(() => {
    if (hasShownRef.current) return;
    const url = new URL(window.location.href);
    if (url.searchParams.get('success') === 'true') {
      hasShownRef.current = true;
      setAlerts([
        {
          type: 'success',
          // @ts-expect-error Need to update IAlert type to allow ReactNode for message
          title: <I18nMessage translate={'preference.update.success.heading'} />,
          message: <I18nMessage translate={'preference.update.success.body'} />
        },
      ]);
      // Delay router.replace so PageAlerts processes the *current* searchParams
      // before receiving the change from replace
      setTimeout(() => {
        router.replace(currentPageURL);
      }, 100);
    }
  }, [currentPageURL, router, setAlerts]);

}
